import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './Banner.module.scss';
import cn from 'classnames';

const Banner = () => {
  const [isMounted, setIsMounted] = useState(false);
  const { t } = useTranslation(['marketing']);

  // Prevent hydration issues by not rendering until client-side
  useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    return null;
  }

  return (
  <>
    <div className={cn(styles.Background, styles.Shadow)}>
      <div className={styles.BallContainer}>
        <img className={styles.FullBall} src="/img/icons/ball_shadow.svg" />
      </div>
    </div>
    <div className={styles.Background}>
      <div className={styles.BallContainer}>
        <img className={styles.FullBall} src="/img/icons/ball.svg" />
      </div>
    </div>

    <div className={styles.Container}>
      <div className={styles.HeaderBanner}>
        <div className={cn(styles.HeaderText, styles.my4)}>
          <h1>{t('landing.banner.collectMoney')}</h1>
          <h1>{t('landing.banner.makeMemories')}</h1>
          <h3>{t('landing.banner.tagline')}</h3>
          <div className={styles.buttonContainer}>
            <a href="https://bouncelife.com/ios">
              <img
                className={cn(styles.storeButton, styles.appStore)}
                src="/img/illustrations/landing/app-store.svg"
              />
            </a>
            <a href="https://bouncelife.com/android">
              <img
                className={styles.storeButton}
                src="/img/illustrations/landing/play-store.svg"
              />
            </a>
          </div>
        </div>
        <div className={cn(styles.iPhoneMockup, styles.my5)}>
          <img
            className={styles.iPhone}
            src="/img/illustrations/landing/iphoneMockup.png"
            alt="Bounce App"
          />
          <div className={styles.Bubbles}>
            <img
              className={styles.Bubble1}
              src="/img/illustrations/landing/Randy.png"
              alt="Bounce"
            />
            <img
              className={styles.Bubble2}
              src="/img/illustrations/landing/Kyara.png"
              alt="Bounce"
            />
            <img
              className={styles.Bubble3}
              src="/img/illustrations/landing/Will.png"
              alt="Bounce"
            />
          </div>
        </div>
      </div>
    </div>
  </>
  );
};

export default Banner;
